import { useContext } from "react";
import StepContext from "../contexts/StepContext";

export const useStep = () => {
  return useContext(StepContext);
};
